import * as React from "react"
import { Info } from "lucide-react"
import {
    Tooltip,
    TooltipContent,
    TooltipProvider,
    TooltipTrigger,
} from "@/components/ui/tooltip"
import { cn } from "@/lib/utils"

interface InfoTooltipProps {
    content: React.ReactNode
    className?: string
    icon?: React.ReactNode
}

export function InfoTooltip({ content, className, icon }: InfoTooltipProps) {
    return (
        <TooltipProvider delayDuration={200}>
            <Tooltip>
                <TooltipTrigger
                    type="button"
                    tabIndex={-1}
                    className={cn("inline-flex items-center justify-center rounded-full text-muted-foreground/60 hover:text-foreground transition-colors outline-none focus-visible:ring-1 focus-visible:ring-ring ml-1.5", className)}
                    onClick={(e: React.MouseEvent<HTMLButtonElement>) => e.preventDefault()}
                >
                    {icon || <Info className="h-4 w-4" />}
                    <span className="sr-only">Más información</span>
                </TooltipTrigger>
                <TooltipContent className="max-w-[280px] break-words text-sm shadow-md" sideOffset={6} align="start">
                    {content}
                </TooltipContent>
            </Tooltip>
        </TooltipProvider>
    )
}
